// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"102":"b783498f","406":"32c842b9"}[chunkId] + ".chunk.css";
};